import type { ShoppingBagItem } from '@ori-events/basket-updated';

export interface MiniBagState {
  isLoading: boolean;
  isDataLoaded: boolean;
  isVisible: boolean;
  items: ShoppingBagItem[];
}

export const initialMiniBagState = {
  isLoading: true,
  isDataLoaded: false,
  isVisible: false,
  items: [],
};
